module.exports = __webpack_public_path__ + "static/media/kz.ee424a69.svg";